<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Discharfe form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Dischargeform",
    };
  },
  computed: {
    ...mapGetters("payments", [
      "PatientInvoiceDetails",
      "PersonalInvoiceStatus",
      "PaymentModes",
    ]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapGetters("inpatient", ["Dischargeform"]),
  },
  methods: {
    ...mapActions({
      PrintDischargeForm: "inpatient/print_dischargeForm",
    }),
  },
  created() {
    this.PrintDischargeForm(this.$route.params.id);
  },
};
</script>
<style scoped>
.print {
  font-family: "Lucida Console", "Courier New", monospace;
}
.para_class {
  margin: 5px;
  font-size: 14px;
}
.padnote {
  margin-bottom: 250px;
}
.headings {
  font-size: 17px;
  font-weight: bold;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row">
      <div class="col-lg-12">
        <div class="d-print-none">
          <div class="float-end">
            <a
           
              href="javascript:window.print()"
              class="btn btn-primary waves-effect waves-light me-1"
              ><i class="fa fa-print"></i> Print</a
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
          
        </div>
        <div class="bg-white p-2 print">
          <div class="invoice-title">
            <div style="width: 100%; top: 0px; height: 130px">
              <div style="width: 50%; float: left; top: 0px">
                <b-spinner
                  v-if="!Dischargeform.clinic"
                  class="m-0"
                  variant="primary"
                  role="status"
                ></b-spinner>
                <img
                  v-else
                  :src="Dischargeform.clinic ? Dischargeform.clinic.clinicLogo : '---'"
                  alt="logo"
                  height="115px"
                />
              </div>

              <div style="width: 50%; float: right; top: 0px">
                <p
                  style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 20px;
                    font-weight: bold;
                  "
                >
                  {{ Dischargeform.clinic ? Dischargeform.clinic.clinicName : "-----" }}
                </p>
                <table align="right" width="100%" style="font-size: 12px">
                  <tr align="right">
                    <td
                      v-html="
                        Dischargeform.clinic ? Dischargeform.clinic.clinicAddress : '---'
                      "
                    ></td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Tel:</strong>
                      {{
                        Dischargeform.clinic ? Dischargeform.clinic.clinicContact : "---"
                      }}
                    </td>
                  </tr>
                  <tr align="right">
                    <td>
                      <strong>Email:</strong>
                      {{ Dischargeform.clinic ? Dischargeform.clinic.clinicMail : "---" }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <hr />

          <div class="row">
            <div class="col-12">
              <table width="100%">
                <h4 style="float: center">INPATIENT DISCHARGE FORM</h4>
                <tr>
                  <td width="50%">
                    <p class="para_class">
                      Ward:<b>{{ Dischargeform.wards ? Dischargeform.wards : "---" }}</b>
                    </p>
                    <p class="para_class">
                      Name:<b>{{
                        Dischargeform.patient ? Dischargeform.patient.patient_name : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Contact:
                      <b>{{
                        Dischargeform.patient
                          ? Dischargeform.patient.patient_contact
                          : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Address:
                      <b>{{
                        Dischargeform.patient
                          ? Dischargeform.patient.patient_address
                          : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Date of Admission:<b>{{
                        Dischargeform.admission_date
                          ? Dischargeform.admission_date
                          : "---"
                      }}</b>
                    </p>
                  </td>
                  <td style="text-align: left">
                    <p class="para_class">
                      Inpatient No.:
                      <b>{{
                        Dischargeform.patient ? Dischargeform.patient.patient_code : "---"
                      }}</b>
                    </p>
                    <p class="para_class">
                      Age.:
                      <strong>
                        {{ Dischargeform.age ? Dischargeform.age : "---" }}
                        <span v-if="Dischargeform.age_unit == 1">Years</span>
                        <span v-if="Dischargeform.age_unit == 2">Months</span>
                        <span v-if="Dischargeform.age_unit == 3">Days</span>
                        <span v-else>--</span>
                      </strong>
                    </p>
                    <p class="para_class">
                      Sex:
                      <strong
                        >{{
                          Dischargeform.patient_gender
                            ? Dischargeform.patient_gender
                            : "---"
                        }}
                      </strong>
                    </p>
                    <p class="para_class">
                      Date of Discharge:
                      <strong
                        >{{
                          Dischargeform.discharge_date
                            ? Dischargeform.discharge_date
                            : "---"
                        }}
                      </strong>
                    </p>
                    <p class="para_class">
                      Status On Discharge:
                      <strong>{{
                        Dischargeform.status ? Dischargeform.status : "---"
                      }}</strong>
                    </p>
                  </td>
                </tr>
              </table>
              <table width="100%">
                <tr class="padnote">
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Provisional Diagnosis</span>: <br />
                     <span v-html='Dischargeform.provisional_diagnosis
                          ? Dischargeform.provisional_diagnosis
                          : "______"'></span>
                    </p>
                  </td>
                </tr>

                <br />
                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Final Diagnosis</span>: <br />
                         <span v-html='Dischargeform.final_diagnosis
                          ? Dischargeform.final_diagnosis
                          : "______"'></span>
                     
                    </p>
                  </td>
                </tr>
                <br />

                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Clinical Presantation of Patient</span>:
                      <br />
                      {{
                        Dischargeform.clinical_presentation
                          ? Dischargeform.clinical_presentation
                          : "---"
                      }}
                    </p>
                  </td>
                </tr>
                <br />

                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Summary of Intervation given</span>: <br />{{
                        Dischargeform.intervation ? Dischargeform.intervation : "---"
                      }}
                    </p>
                  </td>
                </tr>

                <br />
                <tr>
                  <td width="100%">
                    <p style="margin-botton: 10px">
                      <span class="headings">Recommendation on Discharge:</span> <br />
                      {{
                        Dischargeform.reccomendation
                          ? Dischargeform.reccomendation
                          : "---"
                      }}
                    </p>
                  </td>
                </tr>

                <br />
              </table>
            </div>
          </div>

          <div class="table-responsive">
            <table width="100%">
              <tr>
                <td width="50%">
                  <p style="margin: 5px">
                    <span class="headings">Discharge Officer</span>:{{
                      Dischargeform.officer
                        ? Dischargeform.officer
                        : "_________________________________________"
                    }}
                  </p>
                  <p style="margin: 5px">
                    <span class="headings">Signature</span>:{{
                      Dischargeform.staff
                        ? Dischargeform.staff
                        : "_________________________________________________"
                    }}
                  </p>

                  <p style="margin: 5px">
                    <span class="headings">Date of Followup</span>:
                    <span class="para_class">{{
                      Dischargeform.followupdate ? Dischargeform.followupdate : "---"
                    }}</span>
                  </p>
                  <p style="margin: 5px">
                    <span class="headings">Place</span>:<span class="para_class">
                      {{
                        Dischargeform.followupplace ? Dischargeform.followupplace : "---"
                      }}</span
                    >
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
